import React from "react";
import { FaFacebookF, FaInstagram, FaWhatsapp } from "react-icons/fa";


const Footer = () => {
  return (
    <footer className="bg-black text-white px-6 py-10">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left">
        {/* Company Info */}
        <div>
          <h4 className="text-xl font-semibold mb-3">Pentomino Solutions</h4>
          <p className="text-sm text-gray-400">
            Empowering Businesses, Transforming Ideas.
          </p>
          <p className="text-sm text-gray-400 mt-2">
            MSME ID: <span className="text-green-500">UDYAM-KR-03-0458889</span>
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="text-xl font-semibold mb-3">Quick Links</h4>
          <ul className="space-y-2 text-sm text-gray-400">
            <li>
              <a href="/terms" className="hover:text-green-500 transition duration-200">Terms & Conditions</a>
            </li>
            <li>
              <a href="/privacy" className="hover:text-green-500 transition duration-200">Privacy Policy</a>
            </li>
            <li>
              <a href="/refund_policy" className="hover:text-green-500 transition duration-200">Refund policy </a>
            </li>
            <li>
              <a href="/#contact" className="hover:text-green-500 transition duration-200">Contact Us</a>
            </li>
            <li>
              <a href="/#about" className="hover:text-green-500 transition duration-200">About Us</a>
            </li>
          </ul>
        </div>

        {/* Social Media */}
        <div>
          <h4 className="text-xl font-semibold mb-3">Follow Us</h4>
          <div className="flex justify-center md:justify-start space-x-4">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-green-500 text-xl">
              <FaFacebookF />
            </a>
            <a href="https://www.instagram.com/pentomino_solutions" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-green-500 text-xl">
              <FaInstagram />
            </a>
            <a href="https://wa.me/919632383629" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-green-500 text-xl">
              <FaWhatsapp />
            </a>
          </div>
          </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800 mt-10 pt-6 text-center text-sm text-gray-500">
        © {new Date().getFullYear()} Pentomino Solutions. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
